import React, { useEffect, useRef, useState } from "react";
import { Modal as ReactModal } from "react-responsive-modal";
import Styles from "../report.module.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import PortfolioLayout from "../../../../components/Layout/Portfolio";
import SimpleReactValidator from "simple-react-validator";
import AllCategoriesView from "./AssetCategoriesDetailsViews/AllCategoriesView";
import MutualFundReportView from "./AssetCategoriesDetailsViews/MutualFundReportView";
import StocksHoldingsReportView from "./AssetCategoriesDetailsViews/StocksHoldingsReportView";
import FixedDepositBondsReportView from "./AssetCategoriesDetailsViews/FixedDepositBondsReportView";
import AlternateReportView from "./AssetCategoriesDetailsViews/AlternateReportView";
import {
    fetchData,
    fetchEncryptData,
    getParentUserId,
    getPublicMediaURL,
    indianRupeeFormat,
    fetchMembers,
} from "../../../../common_utilities";
import style from "./style.module.css";
import FintooButton from "../../../../components/HTML/FintooButton";
import {
    DMF_GET_ASSETLIST_API_URL,
    DMF_SUMMARY_REPORT_URL,
    DMF_DETAILED_REPORT_URL,
    GET_MEMBER_LIST,
    IS_DIRECT,
    RMF_GET_SC_CHECK_STATUS
} from "../../../../constants";
import { useDispatch } from "react-redux";
import PortfolioGraph from "./PortfolioGraph";
import Calendar from "react-calendar";
import moment from "moment";
import FintooLoader from "../../../../components/FintooLoader";
import FintooDatePicker from "../../../../components/HTML/FintooDatePicker";
import { formatDatefun, formatDate } from "../../../../Utils/Date/DateFormat";

const reportTypeOptions = [
    { value: "", label: "Select" },
    { value: "Summary", label: "Summary Report" },
    { value: "Detailed", label: "Detail Report" },
];

const initialValues = {
    reportType: "",
    assetCategory: "all",
    registrar: "all",
    fromDate: "",
    toDate: ""
};

const AssetBox = ({ title, amount, percentage, color }) => {
    return (
        <div className={style.assetBoxDv}>
            <p className={style.assetBoxTitle}>{title}</p>
            <p className={style.assetBoxAmount}>
                {indianRupeeFormat(amount)}
                <span>({percentage}%)</span>
            </p>
        </div>
    );
};

function PortfolioHoldingsReportDetails() {
    const dispatch = useDispatch();
    const [, forceUpdate] = useState(0);
    const [formData, setFormData] = useState(initialValues);
    useEffect(() => {
        console.log('formDataformData', formData)
        getMemberPan()
    }, [formData])
    const [noteModal, setNoteModal] = useState(false);
    const [currentReportView, setCurrentReportView] = useState(null);
    const [memberDropdownData, setMemberDropdownData] = useState([]);
    const [mainData, setMainData] = useState(null);
    const [hasData, setHasData] = useState(null);
    useEffect(() => {
        console.log('mainDatamainData', mainData)
    }, [mainData])
    const [downloadReport, setDownloadReport] = useState(false);
    const [shareReport, setShareReport] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isReportGenerated, setIsReportGenerated] = useState(false);
    const [reportTitle, setReportTitle] = useState({});
    const [assetCategoryOptions, setAssetCategoryOptions] = useState([]);
    const [userExternalFundData, setUserExternalFundData] = useState([]);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const reportType = params.get('report_type');

    console.log("here", reportType);
    useEffect(() => {
        console.log('userExternalFundDatauserExternalFundData', userExternalFundData)
    }, [userExternalFundData])
    const navigate = useNavigate();
    const membersPan = useRef({});
    const registrarList = [
        { value: "all", label: "All" },
        { value: "fintoo", label: "Fintoo" },
        { value: "other", label: "Other" },
    ];

    const simpleValidator = useRef(new SimpleReactValidator());

    const validateForm = () => {
        // console.log("nilesh234", simpleValidator.current);
        forceUpdate((v) => v + 1);
        simpleValidator.current.showMessages();
        if (simpleValidator.current.allValid() == true) {
            // setCurrentReportView(formData.assetCategory);
            return true;
        }
        return false;
    };

    const getMemberData = async () => {
        try {
            let x = await fetchData({
                url: GET_MEMBER_LIST,
                method: "post",
                data: { user_id: getParentUserId(), is_direct: IS_DIRECT },
            });
            setMemberDropdownData([
                { label: "Family", value: 0 },
                ...x.data.map((v) => ({ label: v.NAME || v.fdmf_email, value: v.id })),
            ]);
        } catch (e) {
            // console.error("err #334 getMemberData", e);
            dispatch({
                type: "RENDER_TOAST",
                payload: {
                    message: "Something went wrong, please try again later.",
                    type: "error",
                },
            });
        }
    };

    useEffect(() => {
        loadInitialData();
    }, []);

    useEffect(() => {
        if (downloadReport) {
            goToGenerate();
            setDownloadReport(false);
        }
        if (shareReport) {
            goToGenerate();
            setShareReport(false);
        }
    }, [downloadReport, shareReport]);

    const loadInitialData = () => {
        getAssetsList();
        getMemberData();
        getMemberPan();
    };

    const getMemberPan = async () => {
        try {
            const memberData = await fetchMembers();
            const selectedMemberId = formData.member
            const newMemberArr = [];

            // loop only over the selected member
            for (const v of memberData) {
                if (selectedMemberId && v.id !== selectedMemberId) continue;

                if (v.pan) {
                    const payload = {
                        method: "post",
                        url: RMF_GET_SC_CHECK_STATUS,
                        data: {
                            pan: v.pan,
                            is_direct: IS_DIRECT,
                        },
                    };

                    const res = await fetchData(payload);

                    if (res.error_code == 100) {

                        res.data.forEach((holding) => {
                            newMemberArr.push({
                                name: `${v.NAME || ''} ${v.middle_name || ''} ${v.last_name || ''}`.trim(),
                                email: v.fdmf_email || '',
                                pan: holding.pan,
                                status: holding.status,
                                created_datetime: holding.Created_Datetime,
                                updated_datetime: holding.Updated_Datetime,
                            });
                        });
                    }
                }
            }
            setUserExternalFundData(newMemberArr);
        } catch (err) {
            console.error("Error in getMemberPan:", err);
        }
    };

    const getAssetsList = async () => {
        try {
            const r = await fetchData({
                url: DMF_GET_ASSETLIST_API_URL,
                method: "post",
                data: {
                    is_direct: IS_DIRECT,
                },
            });

            setAssetCategoryOptions([
                { value: "all", label: "All" },
                ...r.data.map((v) => ({ label: v.asset_name, value: v.asset_type })),
            ]);
        } catch (e) {
            console.error("err2-->", e);
        }
    };

    const generateSummaryReportDefaultResponse = {
        overall_portfolio: { inv_data: [] },
    };

    // console.log("nil221", assetCategoryOptions);

    const getEmptyErrorMessage = () => {
        // console.log("we201", reportTitle, addAssetsPageLinks[reportTitle?.value]);
        let data;
        switch (reportTitle?.value) {
            case "us_equity":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your US Equity data to display.
                            </p>
                        </>
                    ),
                    buttonText: "Add US Equity",
                };
                break;
            case "mutual_fund":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Mutual Fund data to
                                display.
                            </p>
                            <p>You can fetch your existing Mutual Fund Holdings</p>
                        </>
                    ),
                    buttonText: "Fetch Holdings Now",
                };
                break;
            case "stocks":
                data = {
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Stocks data to display.
                            </p>
                        </>
                    ),
                };
                break;
            case "fd_bond":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>Currently it seems we don't have your FD data to display.</p>
                        </>
                    ),
                    buttonText: "Add FD & Bonds",
                };
                break;
            case "govt_scheme":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Govt. Schemes data to
                                display.
                            </p>
                        </>
                    ),
                    buttonText: "Add Existing Scheme",
                };
                break;
            case "alternate":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Alternate data to display.
                            </p>
                        </>
                    ),
                    buttonText: "Add Alternate",
                };
                break;
            case "gold":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Gold Assets data to
                                display.
                            </p>
                        </>
                    ),
                    buttonText: "Add Gold Assets",
                };
                break;
            case "real_estate":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Real Estate data to
                                display.
                            </p>
                        </>
                    ),
                    buttonText: "Add Existing Real Estate",
                };
                break;
            case "liquid":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Liquid Assets data to
                                display.
                            </p>
                        </>
                    ),
                    buttonText: "Add Liquid Assets",
                };
                break;
            case "insurance":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Insurance data to display.
                            </p>
                        </>
                    ),
                    buttonText: "Add Insurance",
                };
                break;
            case "post_office":
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Govt Scheme data to
                                display.
                            </p>
                        </>
                    ),
                    buttonText: "Add Govt. Scheme",
                };
                break;
            case "others":
                data = {
                    buttonText: "Add Other Assets",
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Others data to display.
                            </p>
                        </>
                    ),
                };
                break;
            case "aif_equity":
                data = {
                    buttonText: "Add Unlisted/AIF Equity",
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>
                                Currently it seems we don't have your Unlisted/AIF equity data
                                to display.
                            </p>
                        </>
                    ),
                };
                break;
            default:
                data = {
                    link: "direct-mutual-fund/portfolio/dashboard/",
                    message: (
                        <>
                            <p>Currently it seems we don't have your data to display.</p>
                        </>
                    ),
                };
                break;
        }
        return data;
    };

    const goToGenerate = async () => {
        try {
            if (validateForm()) {
                setIsLoading(true);
                // set report title here
                let title = {};
                let from_date = formData.fromDate;
                let to_date = formData.toDate;
                let api_url = "";
                try {
                    title = assetCategoryOptions.filter(
                        (v) => v.value == (formData.assetCategory || "all")
                    )[0];
                } catch {
                    // do nothing
                }
                setReportTitle(title);
                // end
                // let isDownloadingReport = downloadReport;
                let isDownloadingReport = true;
                let isShareReport = shareReport;

                const finalFormData = {
                    is_direct: IS_DIRECT,
                };
                // if (isDownloadingReport == false) {
                //   finalFormData.action = "viewdata";
                // }

                // if (isShareReport == true) {
                //   finalFormData.action = "email";
                // }
                finalFormData.asset_type = formData.assetCategory;

                if (formData.assetCategory == "mutual_fund") {
                    switch (formData.registrar) {
                        case "all":
                            finalFormData.fund_registrar = "all";
                            break;
                        case "fintoo":
                            finalFormData.fund_registrar = "all";
                            finalFormData.ecas = "0";
                            break;
                        case "other":
                            finalFormData.fund_registrar = "ecas";
                            finalFormData.ecas = "1";
                            break;
                    }
                }
                finalFormData.user_id = formData.member
                    ? ["" + formData.member]
                    : memberDropdownData
                        .filter((v) => Number(v.value) > 0)
                        .map((v) => "" + v.value);

                if (from_date && to_date) {
                    finalFormData.from_date = from_date;
                    finalFormData.to_date = to_date;
                } else if (from_date && !to_date) {
                    finalFormData.from_date = from_date;
                    finalFormData.to_date = new Date().toISOString().split("T")[0];
                } else if (!from_date && to_date) {
                    finalFormData.from_date = "1970-01-01";
                    finalFormData.to_date = to_date;
                }

                if (reportType === "summary") {
                    api_url = DMF_SUMMARY_REPORT_URL;
                }
                if (reportType === "detailed") {
                    api_url = DMF_DETAILED_REPORT_URL;
                }

                console.log("download issue", finalFormData)
                const config = {
                    method: "post",
                    url: api_url,
                    data: finalFormData,
                };
                const r = await fetchData(config);

                if (isDownloadingReport) {
                    if (r.error_code == 102) {
                        setHasData(false);
                        setIsLoading(false);
                        return;
                    } else {
                        setHasData(true)
                        window.open(r.data, "_blank");
                    };
                } else if (isShareReport) {
                    dispatch({
                        type: "RENDER_TOAST",
                        payload: {
                            message: "Email sent successfully.",
                            type: "success",
                        },
                    });
                } else {
                    setMainData(r.data[0]);
                    if (r.data[0]) {
                        setHasData(true)
                    } else {
                        setHasData(false)
                    }
                }
                setIsLoading(false);
            } else {
                throw "Form error";
            }
        } catch {
            console.error("err--->");
        }
    };

    const onDateAndSelectInputChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
    }

    const [openCalendar, setOpenCalendar] = useState(false);
    const refCalendarBox = useRef();

    simpleValidator.current.purgeFields();

    const showMemberTable = () => {

        if (reportType == "summary" || reportType == "detailed") {
            if (formData.assetCategory === "all") {
                return true;
            } else {
                if (formData.assetCategory === "mutual_fund" && (formData.registrar == 'all' || formData.registrar == 'other')) {
                    return true
                } else {
                    return false
                }
            }
        } else {
            return false;
        }
    }
    const showGenerateBtn = () => {
        if (!showMemberTable()) {
            return true;
        } else {
            return !userExternalFundData.some(data =>
                data.status === "Pending" || (new Date() - new Date(data.updated_datetime)) > 1 * 24 * 60 * 60 * 1000
            );
        }
    }

    const handleGenerateClick = () => {
        // goToGenerate()
        // return;
        console.log('showGenerateBtn()', showGenerateBtn());
        if (!showGenerateBtn()) {
            setNoteModal(true);
        } else {
            goToGenerate()
        }
    }

    useEffect(() => {
        setMainData(null);
        setHasData(null);
    }, [formData.assetCategory, formData.member, formData.reportType])

    return (
        <PortfolioLayout>
            <FintooLoader isLoading={isLoading} />
            <div className={`${Styles.ReportDetailSection}`}>
                <div>
                    <Link
                        className="text-decoration-none"
                        to={`${process.env.PUBLIC_URL}/commondashboard/Report`}
                    >
                        <img
                            className="pointer"
                            src={
                                process.env.REACT_APP_STATIC_URL + "media/DMF/left-arrow.svg"
                            }
                            width={25}
                        />
                    </Link>
                </div>
                <div className={`row ${Styles.PortfolioReportSection}`}>
                    <div className="col-12  mt-md-5 mt-4">
                        <div className={`pb-2 ${Styles.insideTabBoxd}`}>
                            <div className="d-flex align-items-center">
                                <div>
                                    <img
                                        src={
                                            process.env.REACT_APP_STATIC_URL +
                                            "media/DMF/Report/01_capital_gains_Loss_report.svg"
                                        }
                                        width={50}
                                    />
                                </div>
                                <div className={`pt-3 ${Styles.ReportName}`}>
                                    {reportType === 'detailed'
                                        ? 'Portfolio Transaction Report'
                                        : 'Portfolio Holdings Report'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="row mt-4">
                        {/* <div className="col">
              <div className={`${Styles.ReportLabel}`}>Type of Report</div>
              <div className="mt-2">
                <Select
                  className="box-shadow-none border-0"
                  classNamePrefix="ReportSelect"
                  isSearchable={false}
                  placeholder="Select.."
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                      ...theme.colors,

                      primary: "#042b62",
                    },
                  })}
                  options={reportTypeOptions}
                  value={
                    reportTypeOptions.filter(
                      (v) => v.value === formData.reportType
                    )[0] ?? ""
                  }
                  onChange={(e) => {
                    onDateAndSelectInputChange("reportType", e.value);
                  }}
                />
              </div>
              {simpleValidator.current.message(
                "reportType",
                formData.reportType,
                "required",
                { messages: { required: "This field is required" } }
              )}
            </div> */}
                        <div className="col">
                            <div className={`${Styles.ReportLabel}`}>Member</div>
                            {/* {console.log("memberDropdownData====>", memberDropdownData)} */}
                            <div className="mt-2">
                                <Select
                                    value={
                                        memberDropdownData.filter(
                                            (v) => v.value == (formData.member ?? 0)
                                        )[0]
                                    }
                                    className="box-shadow-none border-0"
                                    classNamePrefix="ReportSelect"
                                    isSearchable={false}
                                    options={memberDropdownData}
                                    placeholder="Select.."
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 0,
                                        colors: {
                                            ...theme.colors,
                                            primary: "#042b62",
                                        },
                                    })}
                                    onChange={(e) => {
                                        setFormData((prev) => ({
                                            ...prev,
                                            member: e.value,
                                        }));
                                    }}
                                />
                            </div>
                            {simpleValidator.current.message(
                                "assetCategory",
                                formData.assetCategory,
                                "required"
                            )}
                        </div>
                        <div className="col">
                            <div className={`${Styles.ReportLabel}`}>Asset Category</div>
                            <div className="mt-2">
                                <Select
                                    className="box-shadow-none border-0"
                                    classNamePrefix="ReportSelect"
                                    isSearchable={false}
                                    options={assetCategoryOptions}
                                    placeholder="Select.."
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 0,
                                        colors: {
                                            ...theme.colors,

                                            primary: "#042b62",
                                        },
                                    })}
                                    value={
                                        assetCategoryOptions.filter(
                                            (v) => v.value == (formData.assetCategory || "all")
                                        )[0]
                                    }
                                    onChange={(e) => {
                                        onDateAndSelectInputChange("assetCategory", e.value);
                                    }}
                                />
                            </div>
                            {simpleValidator.current.message(
                                "assetCategory",
                                formData.assetCategory,
                                "required"
                            )}
                        </div>
                        <div className="col">
                            {formData?.assetCategory == "mutual_fund" && (
                                <>
                                    <div className="my-2">
                                        <div className={`${Styles.ReportLabel}`}>Investment Platform</div>
                                        <div className="mt-2">
                                            <Select
                                                className="box-shadow-none border-0"
                                                classNamePrefix="ReportSelect"
                                                isSearchable={false}
                                                options={registrarList}
                                                placeholder="Select.."
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,

                                                        primary: "#042b62",
                                                    },
                                                })}
                                                value={
                                                    registrarList.filter(
                                                        (v) => v.value === (formData.registrar ?? "all")
                                                    )[0]
                                                }
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        registrar: e.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* From Date */}
                                    <div className="my-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {/* <div className="mt-2">
                      <label className="me-3">
                        <input
                          type="radio"
                          value="as_on_date"
                          // checked={dateType === 'as_on_date'}
                          onChange={(e) => onDateAndSelectInputChange('as_on_date', formatDate(e))}
                        />{' '}
                        As on Date
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="custom_date"
                          // checked={dateType === 'custom_date'}
                          onChange={(e) => onDateAndSelectInputChange('custom_date', formatDate(e))}
                        />{' '}
                        Custom Date
                      </label>
                    </div> */}
                                        <div>
                                            <div className={`${Styles.ReportLabel}`}>From Date</div>
                                            <div className="mt-2">
                                                <FintooDatePicker
                                                    dateFormat="dd-MM-yyyy"
                                                    selected={formData.fromDate === "" ? new Date('1970-01-01') : new Date(formData.fromDate)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    name='fromDate'
                                                    maxDate={new Date()}
                                                    customClass="datePickerDMF"
                                                    onChange={(e) => onDateAndSelectInputChange('fromDate', formatDate(e))}
                                                    onKeyDown={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className={`${Styles.ReportLabel}`}>To Date</div>
                                            <div className="my-2">
                                                <FintooDatePicker
                                                    dateFormat="dd-MM-yyyy"
                                                    selected={formData.toDate === "" ? new Date() : new Date(formData.toDate)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    name='toDate'
                                                    maxDate={new Date()}
                                                    minDate={formData.fromDate === "" ? new Date('1970-01-01') : new Date(formData.fromDate)}
                                                    customClass="datePickerDMF"
                                                    onChange={(e) => onDateAndSelectInputChange('toDate', formatDate(e))}
                                                    onKeyDown={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="col">
                            <div className={`${Styles.ReportGenOption}`}>
                                <div
                                    className="d-md-block d-none"
                                    style={{
                                        height: "2.3rem",
                                    }}
                                ></div>
                                {
                                    <button
                                        onClick={() => handleGenerateClick()}
                                        className={`${Styles.ReportButton}`}
                                    >
                                        Generate
                                    </button>
                                }

                            </div>
                        </div>
                    </div>
                </div>
                {mainData ? (
                    <>
                        {/* <div className="mt-4">
              <>
                <div className="row my-4">
                  <div className="col-4">
                    <p className={style.reportTextDate}>
                      Report Generated on{" "}
                      <strong>{mainData?.report_date}</strong>
                    </p>
                  </div>
                  <div className={`${style.bottomBtnDv} col-6`}>
                    <div className="d-flex align-items-center">
                      <div
                        className="d-flex align-items-center pointer"
                        onClick={() => setDownloadReport(true)}
                      >
                        <p className="m-0">Download Now</p>
                        <span className="ms-1">
                          <img
                            src={getPublicMediaURL(
                              "/static/media/icons/download-ico.png"
                            )}
                          />
                        </span>
                      </div>
                      <div className={style.emptyLine}></div>
                      <div
                        className="d-flex align-items-center pointer"
                        onClick={() => setShareReport(true)}
                      >
                        <p className="m-0">Share via Email</p>
                        <span className="ms-1">
                          <img
                            className={style.btnIcons}
                            src={getPublicMediaURL(
                              "/static/media/icons/email-ico.png"
                            )}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </div> */}
                    </>
                ) :
                    <>
                        {
                            (hasData === false) && <div className="my-4">
                                <div className="text-center fw-bold mb-0 report-section-paragraphs">
                                    {"message" in getEmptyErrorMessage() &&
                                        getEmptyErrorMessage()["message"]}
                                </div>

                                {"buttonText" in getEmptyErrorMessage() && (
                                    <div className="text-center mt-4">
                                        <Link
                                            to={
                                                process.env.PUBLIC_URL +
                                                "/" +
                                                getEmptyErrorMessage()["link"]
                                            }
                                            className="fintoo-link-button"
                                        >
                                            {getEmptyErrorMessage()["buttonText"]}
                                        </Link>
                                    </div>
                                )}
                                <img
                                    className={`${style["no-results"]} mt-4`}
                                    src={getPublicMediaURL(
                                        "static/media/icons/Investment-data.png"
                                    )}
                                    width={500}
                                />
                            </div>
                        }
                    </>
                }
                {showMemberTable() && (
                    <>
                        {
                            userExternalFundData.length > 0 &&
                            <div className="col-12 col-md-10 mt-md-5 mt-4">
                                <table className="bgStyleTable text-center">
                                    <tbody>
                                        <tr>
                                            <th>Member</th>
                                            <th>Status</th>
                                            <th>
                                                Updated Date
                                            </th>
                                            <th>Action</th>
                                        </tr>
                                        <>
                                            {userExternalFundData?.map((user, index) => (
                                                <tr key={index}>
                                                    <td>{user.name ?? "N/A"}</td>
                                                    <td>{user.status ?? "N/A"}</td>
                                                    <td>{moment(user.updated_datetime).format("DD-MM-YYYY")}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => {
                                                                navigate(
                                                                    process.env.PUBLIC_URL +
                                                                    "/direct-mutual-fund/portfolio/link-your-holdings"
                                                                );
                                                            }}
                                                        >
                                                            {user?.updated_datetime ? (
                                                                <>Refresh</>
                                                            ) : (
                                                                <>Link your holdings</>
                                                            )}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    </tbody>
                                </table>
                            </div>
                        }
                    </>)}


                {/* {"t_inv_val" in mainData && (
          <>
            <p className="mt-5 fw-bold mb-0">{"Asset Category: "+reportTitle?.label}</p>
            <div className="mt-4">
              {Number(mainData.t_inv_val) == 0 &&
                Number(mainData.t_curr_val) == 0 ? (
                <>
                  <div className="my-4">
                    <div className="text-center fw-bold mb-0 report-section-paragraphs">
                      {"message" in getEmptyErrorMessage() &&
                        getEmptyErrorMessage()["message"]}
                    </div>

                    {"buttonText" in getEmptyErrorMessage() && (
                      <div className="text-center mt-4">
                        <Link
                          to={
                            process.env.PUBLIC_URL +
                            "/" +
                            getEmptyErrorMessage()["link"]
                          }
                          className="fintoo-link-button"
                        >
                          {getEmptyErrorMessage()["buttonText"]}
                        </Link>
                      </div>
                    )}
                    <img
                      className={`${style["no-results"]} mt-4`}
                      src={getPublicMediaURL(
                        "static/media/icons/Investment-data.png"
                      )}
                      width={500}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="row my-4">
                    <div className="col-6">
                      <div className={style.assetBoxTableWrapper}>
                        <table className={style.assetBoxTable}>
                          <tbody>
                            {mainData?.inv_data
                              ?.reduce((rows, v, index, array) => {
                                if (index % 3 === 0) {
                                  // Group items in pairs for each row
                                  rows.push(array.slice(index, index + 3));
                                }
                                return rows;
                              }, [])
                              .map((pair, rowIndex) => (
                                <tr key={rowIndex}>
                                  {pair.map((v, colIndex) => (
                                    <td key={colIndex}>
                                      <AssetBox
                                        title={v.label}
                                        amount={v.inv_val}
                                        percentage={v.perc}
                                        color="blue"
                                      />
                                    </td>
                                  ))}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-6">
                      <PortfolioGraph
                        valuation={mainData?.t_curr_val}
                        graphData={(mainData?.inv_data || [])
                          .filter((v) => Number(v.perc) > 0)
                          .map((v) => ({
                            name: v.label,
                            y: Number(v.perc),
                          }))}
                      />
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-4">
                      <p className={style.reportTextDate}>
                        Report Generated on{" "}
                        <strong>{mainData?.report_date}</strong>
                      </p>
                    </div>
                    <div className={`${style.bottomBtnDv} col-6`}>
                      <div className="d-flex align-items-center">
                        <div
                      className={`${style.shareNowDv} d-flex align-items-center position-relative`}
                    >
                      <p className="m-0">Share Now</p>
                      <span className="ms-1">
                        <img
                          src={getPublicMediaURL(
                            "/static/media/icons/share-ico.png"
                          )}
                        />
                      </span>
                      <div className={style.showMoreDv}>
                        <div className={style.showMoreDvInner}>
                          <div className="row">
                            <div
                              className={`col ${style.borderDvRight} ${style.insideWrapper}`}
                            >
                              <div>
                                <p className="m-0 text-center">
                                  <img
                                    className={style.btnIcons}
                                    src={getPublicMediaURL(
                                      "/static/media/icons/email-ico.png"
                                    )}
                                  />
                                </p>
                                <p className="m-0 mt-2 text-center">
                                  Share via Email
                                </p>
                              </div>
                            </div>
                            <div className={`col ${style.insideWrapper}`}>
                              <div>
                                <p className="m-0 text-center">
                                  <img
                                    className={style.btnIcons}
                                    src={getPublicMediaURL(
                                      "/static/media/icons/whatsapp-ico.png"
                                    )}
                                  />
                                </p>
                                <p className="m-0 mt-2 text-center">
                                  Share on WhatsApp
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={style.emptyLine}></div>
                        <div
                          className="d-flex align-items-center pointer"
                          onClick={() => setDownloadReport(true)}
                        >
                          <p className="m-0">Download Now</p>
                          <span className="ms-1">
                            <img
                              src={getPublicMediaURL(
                                "/static/media/icons/download-ico.png"
                              )}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className={`${Styles.categoriesDataContainer}`}>
            {currentReportView === "All" && (
              <AllCategoriesView
                selectedCategoryName={
                  AssetCategoryOptions.filter(
                    (v) => v.value === currentReportView
                  )[0]?.label ?? ""
                }
              />
            )}
            {currentReportView === "MutualFund" && (
              <MutualFundReportView
                selectedCategoryName={
                  AssetCategoryOptions.filter(
                    (v) => v.value === currentReportView
                  )[0]?.label ?? ""
                }
              />
            )}
            {currentReportView === "StocksHoldings" && (
              <StocksHoldingsReportView
                selectedCategoryName={
                  AssetCategoryOptions.filter(
                    (v) => v.value === currentReportView
                  )[0]?.label ?? ""
                }
              />
            )}
            {currentReportView === "FixedDepositBonds" && (
              <FixedDepositBondsReportView
                selectedCategoryName={
                  AssetCategoryOptions.filter(
                    (v) => v.value === currentReportView
                  )[0]?.label ?? ""
                }
              />
            )}
            {currentReportView === "Alternate" && (
              <AlternateReportView
                selectedCategoryName={
                  AssetCategoryOptions.filter(
                    (v) => v.value === currentReportView
                  )[0]?.label ?? ""
                }
              />
            )}
          </div>
          </>
        )} */}
            </div>
            <ReactModal
                classNames={{
                    modal: "ModalpopupContentWidth",
                }}
                open={noteModal}
                showCloseIcon={false}
                center
                animationDuration={0}
                closeOnOverlayClick={false}
                large
            >
                <div className="text-center">
                    <h3 className="HeaderText">Attention !</h3>
                    <div className="">
                        <div
                            className="PopupImg"
                            style={{ width: "40%", margin: "0 auto" }}
                        >
                            <img
                                style={{ width: "100%" }}
                                src={
                                    process.env.PUBLIC_URL +
                                    "/static/media/DMF/SelectingTeam.svg"
                                }
                            />
                        </div>
                        <div className="p-2">
                            <p
                                className="PopupContent"
                                style={{
                                    fontSize: "1.3rem",
                                    fontWeight: "normal",
                                    padding: "0 1rem",
                                    width: "90%",
                                    margin: "0 auto",
                                }}
                            >
                                To ensure your holdings report reflects the most accurate mutual fund data, please click the refresh button to sync your external holdings with the latest information as of today.
                            </p>
                        </div>
                        <div
                            className="ButtonBx aadharPopUpFooter"
                            style={{ display: "flex", justifyContent: "center" }}
                        >
                            <button
                                className="ReNew"
                                onClick={() => {
                                    setNoteModal(false);
                                    // closeModal();
                                    // handleSubmit();
                                }}
                            >
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            </ReactModal>
        </PortfolioLayout>
    );
}

export default PortfolioHoldingsReportDetails;
